export default __webpack_public_path__ + "static/media/Background.b74072a6.svg";